<script>
import authType from '@/store/type/authType'
import Notification from '@/services/Notification/Notification'
import store from '@/store/store'
import Vue from 'vue'
import { i18n } from '@/plugins/i18n'

export default {
    data: () => ({}),
    computed: {},

    async beforeRouteEnter(to, from, next) {
        await store.dispatch(authType.actions.LOGOUT, false)

        if (to.query.impersonate_exit) {
            await Vue.prototype.$impersonate.exit()
            Notification.success(
                i18n.t('notifications.success'),
                i18n.t('notifications.impersonate.exit')
            )
        }
        if (to.query.impersonate_logout) {
            await Vue.prototype.$impersonate.logout()
            Notification.success(
                i18n.t('notifications.success'),
                i18n.t('notifications.impersonate.logout')
            )
        }

        await next('/')
    },

    methods: {},
}
</script>

<template lang="pug">
.auth-wrap.text-center
    transition(name="fade" mode="out-in")
        v-progress-circular(color="primary" indeterminate)
</template>
